import { CustomTextField } from "./CustomTextField";
import React from "react";
import styled from "styled-components";
import { colors } from "../../theme/color";
import Autocomplete from "@mui/material/Autocomplete";

interface CustomAutoCompleteInputInterface {
  id: string;
  placeholder?: string;
  options: { code?: string; label: string }[];
  onSelected?: (item: any, options?: any) => void;
}
export const CustomAutoCompleteInput: React.FC<
  CustomAutoCompleteInputInterface
> = ({ placeholder, id, options, onSelected }) => {
  return (
    <AutoCompleteInput
      sx={{
        "& .MuiAutocomplete-input": {
          padding: "0px 5px",
          height: "10px",
        },
        "& .MuiInputBase-root, & .MuiOutlinedInput-root, & .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-touchedOutline":
          {
            border: "none !important",
          },
      }}
      disablePortal
      id={id}
      options={options}
      renderInput={(params) => (
        <CustomTextField {...params} placeholder={placeholder} />
      )}
      onChange={(_: any, value: any, option: any) =>
        onSelected?.(value, option)
      }
      renderOption={(props: any, option: any, { selected, ...others }) => (
        <AutoCompleteListItem $selected={selected} {...props}>
          {option.code && <strong>{option.code}</strong>}
          {option.label && <span>{option.label}</span>}
        </AutoCompleteListItem>
      )}
    />
  );
};

const AutoCompleteListItem = styled.li`
  border-bottom: 1px solid ${colors.general.brightGray};
  &:last-child {
    border: none;
  }
  padding: 15px;
  color: ${colors.DARK_GRAY};
  font-family: "GT Walsheim Pro";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.28px;
  strong {
    padding-right: 20px;
    display: inline-block;
    width: 12%;
    color: ${colors.BLACK};
    font-weight: 500;
  }
`;
const AutoCompleteInput = styled(Autocomplete)``;

export default CustomAutoCompleteInput;
